// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /payroll/employee_advance/{id}
 *
 * Returns a single `employee_advances` record. The dados is the flat row
 * shape (same fields as Payroll_AdvanceRow) — declared here as concrete
 * typed public properties so the generated runtime schema validates each
 * field instead of an empty `{}`.
 *
 * Money columns (`amount`, `amount_paid`) are MySQL DECIMAL(10,2) and
 * surface as PHP strings via mysqli — typed `string` to match runtime.
 * Datetimes (`created_at`, `updated_at`) are converted GMT-3 → ISO 8601 UTC
 * in the controller before the Response is built. `request_date` is a
 * DATE-only column and stays `YYYY-MM-DD`.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_EmployeeAdvanceResponseDados {
id: number
employee_id: string
franchise_id: number
source_type: string
title: string
amount: string
request_date: string
status: number
amount_paid: string
created_at: string
created_by: string
recebimento_id?: number
origin_period_id?: number
description?: string
despesa_id?: number
updated_at?: string
linked_despesa_status?: number
employee_name?: string
}

export type Payroll_EmployeeAdvanceResponse = ApiResponse<Payroll_EmployeeAdvanceResponseDados>;

registerResponseContract('Payroll_EmployeeAdvanceResponse', {
  id:                    { type: 'number',  required: true },
  employee_id:           { type: 'string',  required: true },
  franchise_id:          { type: 'number',  required: true },
  source_type:           { type: 'string',  required: true },
  title:                 { type: 'string',  required: true },
  amount:                { type: 'string',  required: true },
  request_date:          { type: 'string',  required: true },
  status:                { type: 'number',  required: true },
  amount_paid:           { type: 'string',  required: true },
  created_at:            { type: 'string',  required: true },
  created_by:            { type: 'string',  required: true },
  recebimento_id:        { type: 'number',  required: false },
  origin_period_id:      { type: 'number',  required: false },
  description:           { type: 'string',  required: false },
  despesa_id:            { type: 'number',  required: false },
  updated_at:            { type: 'string',  required: false },
  linked_despesa_status: { type: 'number',  required: false },
  employee_name:         { type: 'string',  required: false },
})
